import { render, staticRenderFns } from "./OzInput.vue?vue&type=template&id=5929219b&scoped=true&"
import script from "./OzInput.vue?vue&type=script&lang=ts&setup=true&"
export * from "./OzInput.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./OzInput.vue?vue&type=style&index=0&id=5929219b&prod&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5929219b",
  null
  
)

export default component.exports